// 资质宝-资质诊断相关接口板块
import request from '@/utils/request'
import { tansParams } from '@/utils'

// 进行诊断结果比对
export const generateDiagnosticResults = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/diagnosticConfiguration/qualificationDiagnosis',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询诊断记录
export const getDiagnosisRecordPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/certificateDiagnosisRecord/queryPage',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询诊断记录详情
export const getDiagnosisRecordDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/certificateDiagnosisRecord/getDetail',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 资质宝-资质诊断报告生成接口
// 目前这个接口暂时是安许的生成，后续看这个接口是否为通用性，若改为了通用性记得删除这段注释
export const generateDiagnosticReport = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/template/zzzdbg',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 诊断报告下载
export function downloadFileRecord(params) {
	return (
		process.env.VUE_APP_BASE_API +
		process.env.VUE_APP_PREFIX_API_CERTTREASURE +
		'/api/template/downloadFile?' +
		tansParams(params)
	)
}
